// eslint-disable-next-line func-style
export function useAlert(message: string) {
	return new Promise<void>((resolve) => {
		// eslint-disable-next-line no-alert
		window.alert(message);
		resolve();
	});
}
